const EMBROIDERY_VARIANTS = {

  

  placements: {
    corner: 51208419279081,
    largeBack: 51208419311849,
    wrapAround: 51208419344617
  },

  applique: {
    enabled: 51208419475689
  },

  textSize: {
    largeText: 51208419508457,
    xlText: 51208419541225
  },

  artworkSize: {
  medium: 51478605562089,
  large: 51478605594857,
  oversized: 51478605627625,
  jumbo: 51478605660393
},

artworkComplexity: {
  moderate: 51478605725929,
  complex: 51478605758697,
  highlyComplex: 51478605791465
},

  threadFinish: {
    metallic: 51208419442921,
    glow: 51208745287913,
    neon: 51208745320681,
    variegated: 51208745353449
  },

  density: {
    premiumFill: 51208750006505,
    luxuryFill: 51208750039273
  },

  stitchType: {
    satin: 51208767570153,
    raised: 51208767602921,
    vintage: 51208767635689
  },

  outline: {
    classic: 51257844793577,
    bold: 51257844826345,
    double: 51257844859113
  },

  shadow: {
    soft: 51257844891881,
    drop: 51257844924649,
    offset: 51257844957417
  },

  monogram: {
    traditional: 51257844990185,
    interlocking: 51257845022953,
    stacked: 51257845055721,
    split: 51257845088489
  },

  puff: {
    puff3d: 51257845121257,
    heavy: 51257845154025
  }

};